import React from 'react'
import useWinnerHandStrength from '@/src/hooks/data/useWinnerHandStrength'
import styles from './A23WinnerHandStrength.module.css'
import useRITCommunityCards from '@/src/hooks/data/useRITCommunityCards'
import { AnimatePresence, motion } from 'motion/react'

export default function A23WinnerHandStrength({ tempTableId }) {
    const { handType, splitPot, multiPots } = useWinnerHandStrength(tempTableId)
    const RITCommunityCards = useRITCommunityCards(tempTableId)

    return <AnimatePresence> {
        handType ? (
            <motion.div
                initial={{
                    opacity: 0,
                    translateX: '-100%'
                }}
                animate={{
                    opacity: 1,
                    translateX: '-50%',
                }}
                exit={{
                    opacity: 0,
                    translateX: '100%',
                }}
                transition={{ duration: 0.5 }}
                style={{ top: RITCommunityCards.length > 0 ? '60%' : '55%' }}
                className={styles.handStrengthContainer}>
                <div className={styles.handStrengthText}>{handType}</div>
            </motion.div>
        ) : null
    }
    </AnimatePresence>
}
